import { fromJS } from 'immutable';
import { basicSort } from '../../../../util/sortUtils';
import { sort } from '../data/volcanoEventReduxConstants';

export const GET_VOLCANO_EVENTS_REQUEST = 'GET_VOLCANO_EVENTS_REQUEST';
export const GET_VOLCANO_EVENTS_SUCCESS = 'GET_VOLCANO_EVENTS_SUCCESS';
export const GET_VOLCANO_EVENTS_FAILURE = 'GET_VOLCANO_EVENTS_FAILURE';
export const CLEAR_VOLCANO_EVENTS = 'CLEAR_VOLCANO_EVENTS';
export const CLEAR_VOLCANO_EVENT_REDIRECT = 'CLEAR_VOLCANO_EVENT_REDIRECT';

export const GET_VOLCANO_EVENT_REQUEST = 'GET_VOLCANO_EVENT_REQUEST';
export const GET_VOLCANO_EVENT_SUCCESS = 'GET_VOLCANO_EVENT_SUCCESS';
export const GET_VOLCANO_EVENT_FAILURE = 'GET_VOLCANO_EVENT_FAILURE';

export const UPDATE_VOLCANO_EVENT_REQUEST = 'UPDATE_VOLCANO_EVENT_REQUEST';
export const UPDATE_VOLCANO_EVENT_SUCCESS = 'UPDATE_VOLCANO_EVENT_SUCCESS';
export const UPDATE_VOLCANO_EVENT_FAILURE = 'UPDATE_VOLCANO_EVENT_FAILURE';

export const CREATE_VOLCANO_EVENT_REQUEST = 'CREATE_VOLCANO_EVENT_REQUEST';
export const CREATE_VOLCANO_EVENT_SUCCESS = 'CREATE_VOLCANO_EVENT_SUCCESS';
export const CREATE_VOLCANO_EVENT_FAILURE = 'CREATE_VOLCANO_EVENT_FAILURE';

export const GET_VOLCANO_EVENT_MORE_INFO_REQUEST = 'GET_VOLCANO_EVENT_MORE_INFO_REQUEST';
export const GET_VOLCANO_EVENT_MORE_INFO_SUCCESS = 'GET_VOLCANO_EVENT_MORE_INFO_SUCCESS';
export const GET_VOLCANO_EVENT_MORE_INFO_FAILURE = 'GET_VOLCANO_EVENT_MORE_INFO_FAILURE';


export const GET_VOLCANO_EVENT_REGION_REQUEST = 'GET_VOLCANO_EVENT_REGION_REQUEST';
export const GET_VOLCANO_EVENT_REGION_SUCCESS = 'GET_VOLCANO_EVENT_REGION_SUCCESS';
export const GET_VOLCANO_EVENT_REGION_FAILURE = 'GET_VOLCANO_EVENT_REGION_FAILURE';

export const GET_VOLCANO_EVENT_COUNTRY_REQUEST = 'GET_VOLCANO_EVENT_COUNTRY_REQUEST';
export const GET_VOLCANO_EVENT_COUNTRY_SUCCESS = 'GET_VOLCANO_EVENT_COUNTRY_SUCCESS';
export const GET_VOLCANO_EVENT_COUNTRY_FAILURE = 'GET_VOLCANO_EVENT_COUNTRY_FAILURE';

export const GET_VOLCANO_EVENT_NAME_REQUEST = 'GET_VOLCANO_EVENT_NAME_REQUEST';
export const GET_VOLCANO_EVENT_NAME_SUCCESS = 'GET_VOLCANO_EVENT_NAME_SUCCESS';
export const GET_VOLCANO_EVENT_NAME_FAILURE = 'GET_VOLCANO_EVENT_NAME_FAILURE';

export const GET_VOLCANO_EVENT_MORPHOLOGY_REQUEST = 'GET_VOLCANO_EVENT_MORPHOLOGY_REQUEST';
export const GET_VOLCANO_EVENT_MORPHOLOGY_SUCCESS = 'GET_VOLCANO_EVENT_MORPHOLOGY_SUCCESS';
export const GET_VOLCANO_EVENT_MORPHOLOGY_FAILURE = 'GET_VOLCANO_EVENT_MORPHOLOGY_FAILURE';

export const VOLCANO_EVENT_DATA_SORT = 'VOLCANO_EVENT_DATA_SORT';


const initialState = fromJS({
  fetched: false,
  loading: false,
  items: [],
  queryParameters: {},
  searchRedirect: false,
  references: [],

  fetchedRegions: false,
  regions: [],
  fetchedCountries: false,
  countries: [],
  fetchedVolcanoNames: false,
  volcanoNames: [],
  fetchedMorphologies: false,
  morphologies: [],

  sort,

});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const volcanoEventSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_VOLCANO_EVENT_REDIRECT:
      return state.set('searchRedirect', false);
    case CLEAR_VOLCANO_EVENTS:
      return initialState.merge(fromJS({
        queryParameters: state.get('queryParameters'),
        sort: state.get('sort'),
      }));
    case VOLCANO_EVENT_DATA_SORT:
      return state.merge(fromJS({
        items: basicSort(action.sort, state.get('items')),
        sort: action.sort,
      }));

    case CREATE_VOLCANO_EVENT_REQUEST:
    case UPDATE_VOLCANO_EVENT_REQUEST:
    case GET_VOLCANO_EVENT_MORE_INFO_REQUEST:
    case GET_VOLCANO_EVENT_REQUEST:
      return state.merge(fromJS({
        fetched: false,
        loading: true,
      }));
    case GET_VOLCANO_EVENTS_REQUEST:
      return state.merge(fromJS({
        fetched: false,
        loading: true,
        queryParameters: action.queryParameters,
        searchRedirect: Boolean(action.searchRedirect),
      }));
    case GET_VOLCANO_EVENTS_SUCCESS:
      return state.merge(fromJS({
        fetched: true,
        loading: false,
        items: basicSort(state.get('sort'), fromJS(action.response.items)),
      }));
    case CREATE_VOLCANO_EVENT_SUCCESS:
    case UPDATE_VOLCANO_EVENT_SUCCESS:
    case GET_VOLCANO_EVENT_MORE_INFO_SUCCESS:
    case GET_VOLCANO_EVENT_SUCCESS:
      return state.merge(fromJS({
        fetched: true,
        loading: false,
        items: [action.response],
      }));
    case CREATE_VOLCANO_EVENT_FAILURE:
    case UPDATE_VOLCANO_EVENT_FAILURE:
    case GET_VOLCANO_EVENT_FAILURE:
    case GET_VOLCANO_EVENT_MORE_INFO_FAILURE:
    case GET_VOLCANO_EVENTS_FAILURE:
      return state.merge(fromJS({
        fetched: true,
        loading: false,
      }));

    case GET_VOLCANO_EVENT_REGION_REQUEST:
      return state.merge(fromJS({
        fetchedRegions: false,
      }));
    case GET_VOLCANO_EVENT_REGION_SUCCESS:
      return state.merge(fromJS({
        fetchedRegions: true,
        regions: action.response.items,
      }));
    case GET_VOLCANO_EVENT_REGION_FAILURE:
      return state.merge(fromJS({
        fetchedRegions: true,
      }));

    case GET_VOLCANO_EVENT_COUNTRY_REQUEST:
      return state.merge(fromJS({
        fetchedCountries: false,
      }));
    case GET_VOLCANO_EVENT_COUNTRY_SUCCESS:
      return state.merge(fromJS({
        fetchedCountries: true,
        countries: action.response.items,
      }));
    case GET_VOLCANO_EVENT_COUNTRY_FAILURE:
      return state.merge(fromJS({
        fetchedCountries: true,
      }));

    case GET_VOLCANO_EVENT_NAME_REQUEST:
      return state.merge(fromJS({
        fetchedVolcanoNames: false,
      }));
    case GET_VOLCANO_EVENT_NAME_SUCCESS:
      return state.merge(fromJS({
        fetchedVolcanoNames: true,
        volcanoNames: action.response.items,
      }));
    case GET_VOLCANO_EVENT_NAME_FAILURE:
      return state.merge(fromJS({
        fetchedVolcanoNames: true,
      }));

    case GET_VOLCANO_EVENT_MORPHOLOGY_REQUEST:
      return state.merge(fromJS({
        fetchedMorphologies: false,
      }));
    case GET_VOLCANO_EVENT_MORPHOLOGY_SUCCESS:
      return state.merge(fromJS({
        fetchedMorphologies: true,
        morphologies: action.response.items,
      }));
    case GET_VOLCANO_EVENT_MORPHOLOGY_FAILURE:
      return state.merge(fromJS({
        fetchedMorphologies: true,
      }));


    default:
      return state;
  }
};
